<div class="container">
  <h1 class="page-title">Company Overview</h1>
  <section class="widget">
    <div class="widget-body">
      <div class="mt">
        <form class="form-horizontal" [formGroup]="form" novalidate>
          <div class="row form-group">
            <label class="col-md-3"><strong>Company:</strong></label>
            <div class="col-md-8">
              <div class="row form-field-spacing" [class.has-danger]="!name.valid && name.touched">
                <span class="required-label col-md-3">Name</span>
                <div class="col-md-8">
                  <input [formControl]="name" class="form-control" type="text"
                         formControlName="name"
                         placeholder="Company Name">
                </div>
              </div>
              <div class="row form-field-spacing">
                      <span class="required-label col-3">UWDA Company</span>
                      <div class="col-md-8">
                      <label class="form-check">
                              <input [formControl]="isUwdaCompany" class="form-check-input"
                                     type="checkbox">
                      </label>
                      </div>
              </div>
              <div class="row form-field-spacing form-group"
                   [class.has-danger]="!regionValue.valid && regionValue.touched">
                <span class="required-label col-3">Regions</span>
                <div class="col-8 p-l-0">
                  <div class="row">
                    <div class="col-12" *ngFor="let region of allRegions">
                        <div class="display-flex">
                          <label class="form-check">
                            <input class="form-check-input"
                                   checkboxArray
                                   [formControl]="regionValue"
                                   type="checkbox"
                                   name="allRegions"
                                   id="regionValue"
                                   [ngValue]="region.key">
                            <span class="required-label form-check-label">{{region.lookupValue}}</span>
                          </label>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row form-field-spacing">
                <span class="col-md-3">Fund Types</span>
                <div class="p-l-0 col-md-8">
                  <pledgeTypeCheckbox [control]="pledgeTypeIds"></pledgeTypeCheckbox>
                </div>
              </div>

              <div class="row form-field-spacing" [class.has-danger]="!status.valid && status.touched">
                <span class="required-label col-md-3">Status</span>
                <div class="col-md-8">
                  <select [formControl]="status" required class="form-select"
                          type="text"
                          formControlName="status">
                    <option value="null">Choose a Status</option>
                    <option *ngFor="let enumName of statuses" [value]="enumName.key">{{enumName.key}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-3"><strong>Address: </strong></label>
            <div class="col-md-8">
              <div class="row form-field-spacing"
                   [class.has-danger]="!address1.valid && address1.touched">
                <span class="required-label col-md-3">Address</span>
                <div class="col-md-8">
                  <input [formControl]="address1" required class="form-control" type="text"
                         formControlName="address1" placeholder="Address">
                </div>
              </div>
              <div class="row form-field-spacing">
                <span class="col-md-3">Unit/Suite</span>
                <div class="col-md-8">
                  <input [formControl]="address2" class="form-control" type="text"
                         formControlName="address2"
                         placeholder="Unit/Suite">
                </div>
              </div>
              <div class="row form-field-spacing" [class.has-danger]="!city.valid && city.touched">
                <span class="required-label col-md-3">City</span>
                <div class="col-md-8">
                  <input [formControl]="city" required class="form-control" type="text"
                         formControlName="city"
                         placeholder="City">
                </div>
              </div>
              <div class="row form-field-spacing" [class.has-danger]="!state.valid && state.touched">
                <span class="required-label col-md-3">State</span>
                <div class="col-md-8">
                  <select [formControl]="state" required class="form-select"
                          type="text"
                          formControlName="state" placeholder="State">
                    <option value="null">Choose a State</option>
                    <option *ngFor="let state of states" [value]="state.key">{{state.lookupValue}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row form-field-spacing" [class.has-danger]="!zipCode.valid && zipCode.touched">
                <span class="required-label col-md-3">Zipcode</span>
                <div class="col-md-8">
                  <input [formControl]="zipCode" required class="form-control" type="text"
                         formControlName="zipCode" placeholder="Zipcode" numbersOnly>
                </div>
              </div>
              <div class="row form-field-spacing">
                <span class="col-md-3">Url Link</span>
                <div class="col-md-8">
                  <input [formControl]="urlLink" class="form-control" type="text"
                         formControlName="urlLink" placeholder="http://www.company.com">
                </div>
              </div>
              <div class="row form-field-spacing">
                <span class="col-md-3">Url Button Title</span>
                <div class="col-md-8">
                  <input [formControl]="urlDisplay" class="form-control" type="text"
                         formControlName="urlDisplay" placeholder="Button Name">
                </div>
              </div>
              <div class="row form-field-spacing">
                <span class="col-md-3">Sort Order</span>
                <div class="col-md-8">
                  <input [formControl]="sortOrder" class="form-control" numbersOnly type="text"
                         formControlName="sortOrder" placeholder="Sort Order">
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-3"><strong>Contact Info: </strong></label>
            <div class="col-md-8">
              <div class="row form-field-spacing">
                <span class="col-md-3">Contact Name 1</span>
                <div class="col-md-8">
                  <input [formControl]="contactName1" class="form-control" type="text"
                         formControlName="contactName1" placeholder="Contact Name">
                </div>
              </div>
              <div class="row form-field-spacing">
                <span class="col-md-3">Contact Phone 1</span>
                <div class="col-md-8">
                  <input [formControl]="contactPhone1" class="form-control" type="text"
                         formControlName="contactPhone1" placeholder="Phone"
                         [imask]="phoneMask">
                </div>
              </div>
              <div class="row form-field-spacing">
                <span class="col-md-3">Contact Name 2</span>
                <div class="col-md-8">
                  <input [formControl]="contactName2" class="form-control" type="text"
                         formControlName="contactName2" placeholder="Contact Name">
                </div>
              </div>
              <div class="row form-field-spacing">
                <span class="col-md-3">Contact Phone 2</span>
                <div class="col-md-8">
                  <input [formControl]="contactPhone2" class="form-control" type="text"
                         formControlName="contactPhone2" placeholder="Phone"
                         [imask]="phoneMask">
                </div>
              </div>
              <div class="row form-field-spacing">
                <span class="col-md-3">Contact Name 3</span>
                <div class="col-md-8">
                  <input [formControl]="contactName3" class="form-control" type="text"
                         formControlName="contactName3" placeholder="Contact Name">
                </div>
              </div>
              <div class="row form-field-spacing">
                <span class="col-md-3">Contact Phone 3</span>
                <div class="col-md-8">
                  <input [formControl]="contactPhone3" class="form-control" type="text"
                         formControlName="contactPhone3" placeholder="Phone"
                         [imask]="phoneMask">
                </div>
              </div>
              <div class="row form-field-spacing"  [class.has-danger]="!payeeType.valid && payeeType.touched">
                <span class="required-label col-md-3">Payee Type</span>
                  <div class="col-md-8">
                    <select [formControl]="payeeType"
                            required
                            type="text"
                            class="form-select"
                            formControlName="payeeType"
                    >
                        <option [ngValue]="null">Choose Company or Individual Payee</option>
                        <option *ngFor="let payeeType of payeeTypesSelect"
                                [value]="payeeType.key">{{payeeType.value}}</option>
                    </select>
                  </div>
              </div>
                <div class="row form-field-spacing"  [class.has-danger]="!category.valid && category.touched">
                    <span class="required-label col-md-3">Category</span>
                    <div class="col-md-8">
                      <select [formControl]="category"
                              required
                              type="text"
                              class="form-select"
                              formControlName="category"
                      >
                          <option [ngValue]="null">Choose a Category</option>
                          <option *ngFor="let category of categorySelect"
                                  [value]="category.key">{{category.value}}</option>
                      </select>
                    </div>
                </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-3"><strong>Account Validation Rules</strong></label>
            <div class="col-md-8">
              <div class="row">
                <span class="col-md-3">Enforce Validation</span>
                <div class="col-md-8">
                  <div class="custom-checkbox-padding">
                    <label class="form-check">
                      <input [formControl]="isAccountValidationEnforced" type="checkbox"
                             class="form-check-input"
                             formControlName="isAccountValidationEnforced"
                             id="isAccountValidationEnforced">
                      <span class="form-check-label">Enforce Account # validation during Pledge Entry?</span>
                    </label>
                  </div>
                </div>
              </div>
              <div *ngIf="isAccountValidationEnforced.value">
                <div class="row">
                  <span class="col-md-3">Valid Characters</span>
                  <div class="col-md-8">
                    <div>
                      <label class="form-check">
                        <input [formControl]="isAccountValid"
                               value="numeric"
                               class="form-check-input"
                               type="radio" name="setAccountValidationDetails"
                               id="isAccountValidNumerical">
                        <span class="form-check-label">Allow only numeric characters for the Account #</span>
                      </label>
                      <label class="form-check">
                        <input [formControl]="isAccountValid"
                               value="alphabetical"
                               class="form-check-input"
                               type="radio" name="setAccountValidationDetails"
                               id="isAccountValidAlphabetical">
                        <span
                          class="form-check-label">Allow only alphabetical characters for the Account #</span>
                      </label>
                      <label class="form-check">
                        <input [formControl]="isAccountValid"
                               value="alphabeticalAndNumeric"
                               class="form-check-input"
                               type="radio"
                               id="setAccountValidationBoth"
                        name="setAccountValidationBoth">
                        <span
                          class="form-check-label">Allow alpha & numeric characters for the Account #</span>
                      </label>
                    </div>
                    <div class="custom-checkbox-padding">
                      <label class="form-check">
                        <input [formControl]="isAccountValidSpecialChars" type="checkbox"
                               class="form-check-input"
                               formControlName="isAccountValidSpecialChars"
                               id="isAccountValidSpecialChars">
                        <span
                          class="form-check-label">Allow special characters (i.e. spaces, dashes, etc.)</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row form-field-spacing">
                  <span class="col-md-3">Min # of characters</span>
                  <div class="col-md-8">
                    <input [formControl]="accountValidationMinLen" class="form-control"
                           type="text" numbersOnly
                           formControlName="accountValidationMinLen">
                  </div>
                </div>
                <div class="row form-field-spacing">
                  <span class="col-md-3">Max # of characters</span>
                  <div class="col-md-8">
                    <input [formControl]="accountValidationMaxLen" class="form-control"
                           type="text" numbersOnly
                           formControlName="accountValidationMaxLen">
                  </div>
                </div>
                <div class="row form-field-spacing">
                  <span class="col-md-3">Account Validation Error Message</span>
                  <div class="col-md-8">
                    <textarea [formControl]="accountValidationErrorMsg" class="form-control"
                              formControlName="accountValidationErrorMsg"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--submit-->
          <div class="row form-group">
            <div class="col-md-3">
            </div>
            <div class="col-md-8 btn-form">
                <div class="display-flex flex-row align-items-center justify-content-end w-100">
                    <!--delete-->
                    <button type="button"
                            class="btn btn-inverse me-4"
                            (click)="showPromptModal()">Delete Company
                    </button>
                    <!--save-->
                    <button [disable]="isValidSave()"
                            [autoDisable]="submit"
                            type="submit"
                            class="btn btn-primary me-2">Save Company
                    </button>
                    <cancel-button [route]="'/app/companies'"></cancel-button>
                </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <prompt-dialog
      [titleText]="'Delete Company?'"
      [promptText]="'Are you sure you want to delete this company?'">
    </prompt-dialog>
  </section>
</div>
